export let ChatListenerEvent = /*#__PURE__*/function (ChatListenerEvent) {
  /**
   * Invoked when a chat is picked up.
   */
  ChatListenerEvent["CHAT_ATTENDED"] = "EVENT_CHAT_ATTENDED";
  /**
   * Invoked when a chat is ended.
   */
  ChatListenerEvent["CHAT_CLOSED"] = "EVENT_CHAT_CLOSED";
  /**
   * Invoked when feedback is given by the visitor.
   */
  ChatListenerEvent["FEEDBACK_RECEIVED"] = "EVENT_FEEDBACK_RECEIVED";
  /**
   * Invoked when a chat is missed.
   */
  ChatListenerEvent["CHAT_MISSED"] = "EVENT_CHAT_MISSED";
  /**
   * Invoked when a chat is initiated.
   */
  ChatListenerEvent["CHAT_OPENED"] = "EVENT_CHAT_OPENED";
  /**
   * Invoked when the position in the queue of a queued chat changes.
   */
  ChatListenerEvent["CHAT_QUEUE_POSITION_CHANGED"] = "EVENT_CHAT_QUEUE_POSITION_CHANGED";
  /**
   * Invoked when a chat is rated by the visitor.
   */
  ChatListenerEvent["RATING_RECEIVED"] = "EVENT_RATING_RECEIVED";
  /**
   * Invoked when a chat is reopened.
   */
  ChatListenerEvent["CHAT_REOPENED"] = "EVENT_CHAT_REOPENED";
  /**
   * Invoked when the unread count is changed.
   */
  ChatListenerEvent["CHAT_UNREAD_COUNT_CHANGED"] = "EVENT_CHAT_UNREAD_COUNT_CHANGED";
  /**
   * Invoked when a URL in the chat is clicked.
   */
  ChatListenerEvent["HANDLE_URL"] = "EVENT_HANDLE_URL";
  /**
   * Invoked when a chat action is to be executed. {@link https://www.zoho.com/salesiq/help/developer-section/react-native-sdk-chatactions-v2.html Learn More}
   */
  ChatListenerEvent["PERFORM_CHATACTION"] = "EVENT_PERFORM_CHATACTION";
  /**
   * Invoked when a chat window is closed.
   */
  ChatListenerEvent["CHAT_VIEW_CLOSED"] = "EVENT_CHATVIEW_CLOSED";
  /**
   * Invoked when a chat window is opened.
   */
  ChatListenerEvent["CHAT_VIEW_OPENED"] = "EVENT_CHATVIEW_OPENED";
  /**
   * Invoked when a custom trigger is executed. {@link http://www.zoho.com/salesiq/help/developer-section/react-native-sdk-custom-trigger.html Learn More}
   */
  ChatListenerEvent["CUSTOM_TRIGGER"] = "EVENT_CUSTOMTRIGGER";
  /**
   * Invoked when a bot has been triggered.
   * 
   * Note: Android only
   */
  ChatListenerEvent["BOT_TRIGGER"] = "EVENT_BOT_TRIGGER";
  return ChatListenerEvent;
}({});
//# sourceMappingURL=Listener.js.map